import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'underscore';

import notices from './notices';

Vue.use(Vuex);

const store = new Vuex.Store({

    state: {
        user: window.user,
        account: window.account || {},
        childSelectorOpen: false,
        children: window.children || [],
        activeChildId: window.activeChildId || null,
        inKidMode: window.inKidMode,
    },

    getters: {

        inKidMode(state) {
            return state.inKidMode;
        },

        child(state) {
            return _.findWhere(state.children, { id: state.activeChildId }) || {};
        },

    },

    mutations: {

        openChildSelector(state) {
            state.childSelectorOpen = true;
        },

        closeChildSelector(state) {
            state.childSelectorOpen = false;
        },
    },

    actions: {

        openChildSelector({ commit }) {
            commit('openChildSelector');
        },

        closeChildSelector({ commit }) {
            commit('closeChildSelector')
        },
    },

    modules: {
        notices,
    },

});

export default store;



// WEBPACK FOOTER //
// ./resources/js/store/index.js